/* eslint-disable no-nested-ternary */
/* eslint-disable no-unused-vars */
import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import { useSnackbar } from 'notistack';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { Box, Typography, Button, Grid } from '@mui/material';
import { styled } from '@mui/material/styles';
import Stack from '@mui/material/Stack';

import { isEmpty } from 'underscore';

// components
import CircularLoading from '../../common/CircularLoading';
// action
import { getStageList, resetPhase } from '../../../redux/slice/stage';
import { setOpenRole, setRecord } from '../../../redux/slice/apply';
// utils
import { stageTime } from '../../../utils/formatTime';
// import poleungkuk from '../../../assets/images/loagin/poleungkuk.png';

import { dateMomentFormat } from '../../../config/dateFormat';

const FlexDiv = styled('div')({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
});

export default function Phasepage(props) {
  const { shut, cutLogin, cut } = props;
  const { enqueueSnackbar } = useSnackbar();
  const params = useLocation();
  const dispatch = useDispatch();
  const { stageList, stageLoading, currentPhase, stageId } = useSelector(
    (state) => state.stage
  );
  // eslint-disable-next-line camelcase
  const { permit_list } = useSelector((state) => state.merchant);

  // 路由跳转
  const navigate = useNavigate();
  const { t } = useTranslation('applyFor');
  const { t: tCom } = useTranslation('common');

  const [data, setData] = useState(
    stageId ? stageList.find((item) => item?.id === stageId) : {}
  );

  useEffect(() => {
    setData(stageList.find((item) => item?.id === stageId));
  }, [stageId]);

  const [confirm, setConfirm] = useState(undefined);

  // const [judge, setJudge] = useState(true);

  useEffect(() => {
    if (stageList[0] && !stageId) {
      setData(stageList[0]);
    }
  }, [stageList]);

  useEffect(() => {
    // if (stageList.length === 0) {
    dispatch(
      getStageList({
        errCallBack: () => {
          enqueueSnackbar(tCom('not_data'), {
            variant: 'error',
          });
        },
      })
    );
    // }
    return () => setConfirm(undefined);
  }, []);

  useEffect(() => {
    if (confirm && confirm === currentPhase?.display_id) {
      if (params?.pathname !== '/login') {
        shut(false);
      }
      navigate('/dashboard/apply-for');
    }
  }, [confirm, currentPhase]);

  const onChoice = (value) => setData(value);

  const onHomepage = () => {
    if (data?.id) {
      dispatch(resetPhase());
      const targetStage = (stageList || []).find(
        (item) => item?.id === data?.id
      );
      dispatch({
        type: 'connection/switch-channel',
        payload: {
          channel: targetStage?.display_id,
        },
      });
      setConfirm(targetStage?.display_id);
      // dispatch(setOpenRole(true));
      dispatch(setRecord(false));
    }
  };

  const gobackHandle = () => {
    navigate('/login', { state: { page: 1, previous: true } });
  };

  // useEffect(() => {
  //   if (data.length !== 0) {
  //     setJudge(false);
  //   } else {
  //     setJudge(true);
  //   }
  // }, [data]);

  return (
    <Box
      sx={{
        width: { xs: '98vw', md: 820 },
        position: 'relative',
        background: '#fff',
        borderRadius: '10px',
        padding: '34px 54px 16px 54px',
        boxSizing: 'border-box',
        minHeight: '400px',
      }}
    >
      <FlexDiv>
        <Typography
          variant="body1"
          gutterBottom
          sx={{
            fontSize: '26px',
            mb: 0,
            fontWeight: '700',
          }}
        >
          {t('phase')}
        </Typography>
      </FlexDiv>
      <Box sx={{ mt: 4, maxHeight: '280px', overflowY: 'auto' }}>
        <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
          <Typography
            variant="body1"
            gutterBottom
            sx={{ ml: '16px', fontSize: '16px' }}
          >
            {t('Name_interview')}
          </Typography>
          <Typography
            variant="body1"
            gutterBottom
            sx={{ ml: { xs: '30px', sm: '65px' }, fontSize: '16px' }}
          >
            {t('data_date')}
          </Typography>
          <Typography
            variant="body1"
            gutterBottom
            sx={{ mr: '54px', fontSize: '16px' }}
          >
            {t('group')}
          </Typography>
        </Box>
        {stageLoading || confirm ? (
          <Box sx={{ position: 'relative', minHeight: '120px' }}>
            <CircularLoading position="absolute" />
          </Box>
        ) : (stageList || []).length > 0 ? (
          <Box sx={{ mr: 1 }}>
            {(stageList || []).map((item) => (
              <Box
                key={item?.id}
                sx={{
                  borderRadius: '10px',
                  border:
                    data?.id === item?.id
                      ? '1px solid #22AFFF'
                      : '1px solid #D4D4D4',
                  pt: '19px',
                  pb: '19px',
                  boxSizing: 'border-box',
                  display: 'flex',
                  justifyContent: 'space-between',
                  mt: '12px',
                  cursor: 'pointer'
                }}
                onClick={() => onChoice(item)}
              >
                <Typography
                  variant="body1"
                  gutterBottom
                  sx={{ mb: '0px', ml: 2, width: '30%', fontSize: '18px' }}
                >
                  {item.name}
                </Typography>
                <Typography
                  variant="body1"
                  gutterBottom
                  sx={{
                    fontSize: '18px',
                    width: '50%',
                    textAlign: 'center',
                  }}
                >
                  {`${dateMomentFormat(item?.start_date)} - ${dateMomentFormat(
                    item?.end_date
                  )}`}
                </Typography>
                <Typography
                  variant="body1"
                  gutterBottom
                  sx={{
                    mb: '0px',
                    width: '20%',
                    fontSize: '18px',
                    mr: '65px',
                    textAlign: 'right',
                  }}
                >
                  {item.total_group}
                </Typography>
              </Box>
            ))}
          </Box>
        ) : (
          <Stack direction="row" spacing={2} justifyContent="center">
            <Typography
              variant="h4"
              gutterBottom
              component="div"
              sx={{ my: 3 }}
            >
              {t('not_info')}
            </Typography>
          </Stack>
        )}
      </Box>
      {!stageLoading && (stageList || []).length > 0 && (
        <FlexDiv sx={{ pt: 2 }}>
          <Button
            variant="contained"
            disabled={!data?.id}
            sx={{ width: '170px', height: '38px', background: '#22AFFF' }}
            onClick={onHomepage}
          >
            {t('determine')}
          </Button>
        </FlexDiv>
      )}
      {!stageLoading && (stageList || []).length === 0 && (
        <FlexDiv sx={{ pt: 2 }}>
          <Button
            variant="contained"
            sx={{ width: '170px', height: '38px', background: '#22AFFF' }}
            onClick={permit_list.length === 1 ? cutLogin : cut}
          >
            {permit_list.length === 1 ? t('logout') : t('returns')}
          </Button>
        </FlexDiv>
      )}
    </Box>
  );
}

Phasepage.propTypes = {
  // eslint-disable-next-line react/require-default-props
  shut: PropTypes.func,
  // eslint-disable-next-line react/require-default-props
  cutLogin: PropTypes.func,
  cut: PropTypes.func.isRequired,
};
